import React from 'react';
import { Helmet } from "react-helmet";
import {
  Title,
  SubTitle,
  BodyText,
} from '@minerva-analytics/pantheon';
import AboutImage1 from '../../assets/graphic1@3x.png';
import { 
  AboutContainer, 
  AboutHeader, 
  AboutSubHeader, 
  AboutSection, 
  TextSection, 
  AboutImage,
  SecondAboutSection,
  WhiteSubTitle,
  WhiteBodyText,
  SecondTextSection
} from './About.styles';

const About = () => {
  return (
    <>
      <Helmet>
        <title>About Us | The Daily Atom</title>
        <meta
          name="og:title"
          property="og:title"
          content="About Us | Keep It Reel"
        />
        <meta
          name="og:description"
          property="og:description"
          content="The Daily Atom is dedicated to bringing you interesting, engaging, and fun science facts every day! Learn more about us and why we do what we do here."
        />
        <meta
          name="description"
          property="description"
          content="The Daily Atom is dedicated to bringing you interesting, engaging, and fun science facts every day! Learn more about us and why we do what we do here."
        />
      </Helmet>
      <AboutContainer>

        <AboutHeader>
          <Title>About The Daily Atom</Title>
          <AboutSubHeader>Daily science facts and trivia</AboutSubHeader>
        </AboutHeader>

        <AboutSection>
          <TextSection>
            <SubTitle>Hassle-Free Learning Delivered Right to You</SubTitle>
            <BodyText>Many people are curious and want to learn more about the scientific world and how things work. But it can be hard to know where to start on your own. Not to mention, life is busy and most of us don’t have a lot of time to spare. That’s why we created The Daily Atom. We want to make it easy to learn a little something new every day! From interesting science facts and trivia to fascinating science history, we’ll send you a new tidbit of science information each day. Our email newsletter is simple, informative, and easy to digest. In just a few sentences, you’ll learn something new! There’s no need to dedicate a lot of time or energy to it – with The Daily Atom, learning a new science fact is as easy as checking your email! And did we mention? The Daily Atom is completely free!</BodyText>
          </TextSection>
          <AboutImage src={AboutImage1} />
        </AboutSection>

        <SecondAboutSection>
          <SecondTextSection>
            <WhiteSubTitle>Interesting & Shareable Science Facts</WhiteSubTitle>
            <WhiteBodyText>We are dedicated to bringing you interesting, engaging, and fun science facts every day! That’s why we carefully curate our email newsletter to include the most interesting science facts, trivia, and history. We know that you don’t have a lot of time to spare, so we always make sure our content is easy to enjoy at a glance. We also make sure it’s simple to digest and easy to share! Why? Well, our newsletter is a great way to learn a little something new each day on your own. But it’s also a fun way to learn new science trivia to share! Our science facts make great conversation starters and can even be used as a learning aid to spark discussions about science with kids. You never know what science fact or piece of science trivia you’ll receive in your inbox, but you can be sure that it will be interesting!</WhiteBodyText>
          </SecondTextSection>
        </SecondAboutSection>
      </AboutContainer>
    </>
  );
};

export default About;
